import _ from 'lodash';

export function isArray(arr: unknown) {
	return Array.isArray(arr);
}

export function isValidDate(date: string) {
	const $date = Date.parse(date);
	return !isNaN($date);
}

export function flattenKeys(object: any, initialPathPrefix = ''): Record<string, any> {
	if (!object || typeof object !== 'object') {
		return [{ [initialPathPrefix]: object }];
	}
	const prefix = initialPathPrefix ? (Array.isArray(object) ? initialPathPrefix : `${initialPathPrefix}.`) : '';
	return Object.keys(object)
		.flatMap((key) => flattenKeys(object[key], Array.isArray(object) ? `${prefix}[${key}]` : `${prefix}${key}`))
		.reduce((acc, path) => ({ ...acc, ...path }));
}
